<script>
export default {
  props: {
    color: {
      type: String,
      default: '',
    },
  },
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    overflow="visible"
    :fill="color"
    stroke="none"
  >
    <defs>
      <rect
        id="loader"
        x="46.5"
        y="40"
        width="7"
        height="20"
        rx="2"
        ry="2"
        transform="translate(0 -30)"
      />
    </defs>
    <g class="loader" transform="rotate(30 50 50)">
      <use xlink:href="#loader" />
    </g>
    <g class="loader" transform="rotate(60 50 50)">
      <use xlink:href="#loader" />
    </g>
    <g class="loader" transform="rotate(90 50 50)">
      <use xlink:href="#loader" />
    </g>
    <g class="loader" transform="rotate(120 50 50)">
      <use xlink:href="#loader" />
    </g>
    <g class="loader" transform="rotate(150 50 50)">
      <use xlink:href="#loader" />
    </g>
    <g class="loader" transform="rotate(180 50 50)">
      <use xlink:href="#loader" />
    </g>
    <g class="loader" transform="rotate(210 50 50)">
      <use xlink:href="#loader" />
    </g>
    <g class="loader" transform="rotate(240 50 50)">
      <use xlink:href="#loader" />
    </g>
    <g class="loader" transform="rotate(270 50 50)">
      <use xlink:href="#loader" />
    </g>
    <g class="loader" transform="rotate(300 50 50)">
      <use xlink:href="#loader" />
    </g>
    <g class="loader" transform="rotate(330 50 50)">
      <use xlink:href="#loader" />
    </g>
    <g class="loader" transform="rotate(360 50 50)">
      <use xlink:href="#loader" />
    </g>
  </svg>
</template>
<style lang="scss">
@for $i from 1 to 13 {
  .loader:nth-of-type(#{$i}) * {
    animation: 1s $i * 0.08s opacityLoader infinite;
  }
}
@keyframes opacityLoader {
  to {
    opacity: 0;
  }
}
svg {
  width: 100%;
  height: 100%;
}
</style>
